/*
 * @Description:
 * @Date: 2024-11-29 11:37:12
 */
import appStore from '@/store';
import { storeToRefs } from 'pinia';
import { RouteLocationNormalized } from 'vue-router';

export default async (to: RouteLocationNormalized, next) => {
  const { menuUrls, menu } = storeToRefs(appStore.useMenuStoreSetup);
  // 同步菜单
  if (!menuUrls.value.length) {
    await appStore.useMenuStoreSetup.setMenus(); // 就是这个影响的
    next(menuUrls.value[0]);
    return Promise.reject('菜单重载重定向');
  }
  if (menu.value?.id) {
    // 阻塞路由，有数据后才能正常进入
    await appStore.useResourceStoreSetup.setResource(menu.value.id);
  }
  return Promise.resolve();
};
